module.exports = __WEBPACK_EXTERNAL_MODULE_83__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 83
// module chunks = 0